// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import WidgetClassContentItemViewModel from '../../../../viewModel/resource/WidgetClassContentItemViewModel';
import WidgetClassContentItemDTO from '../../dto/resource/WidgetClassContentItemDTO';

export default abstract class WidgetClassContentItemModel extends BaseModel<WidgetClassContentItemDTO> {
  /**
  * @type {int32}
  */
  get order() { return this.dto.order; }
  set order(value) { this.dto.order = value; }
  /**
  */
  get isBulletPoint() { return this.dto.isBulletPoint; }
  set isBulletPoint(value) { this.dto.isBulletPoint = value; }
  /**
  */
  get text() { return this.dto.text; }
  set text(value) { this.dto.text = value; }
  /**
  */
  get wordText() { return this.dto.wordText; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.order);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.order = value;
    value = qs.isBulletPoint === 'true' ? true : qs.isbulletpoint;
    value = qs.isBulletPoint === 'false' ? false : undefined;
    this.dto.isBulletPoint = value;
    this.dto.text = qs.text;
  }
}
